import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=3dda8e6b"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dda8e6b')) {
      api.createRecord('3dda8e6b', component.options)
    } else {
      api.reload('3dda8e6b', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=3dda8e6b", function () {
      api.rerender('3dda8e6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Product.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Product.vue
// module id = 6
// module chunks = 0